import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const SaveConfirmModal = ({ open, onClose, onConfirm }) => {
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: '-4px -4px 12px 0px rgba(0,0,0,0.08), 4px 4px 12px 0px rgba(0,0,0,0.08)',
    borderRadius: '8px',
    p: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    alignItems: 'center',
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="save-confirm-modal-title">
      <Box sx={modalStyle}>
        {/* 내용 */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center', textAlign: 'center' }}>
          <Typography
            id="save-confirm-modal-title"
            sx={{
              fontSize: '24px',
              fontWeight: 700,
              color: '#262626',
              lineHeight: 1.5,
            }}>
            설정을 저장 하시겠습니까?
          </Typography>
          <Box>
            <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#737373', lineHeight: 1.5 }}>
              설정을 저장하지 않으면 지금까지 변경한 내용은 모두 반영되지 않으며,
            </Typography>
            <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#737373', lineHeight: 1.5 }}>
              이전에 저장된 설정 상태로 유지됩니다.
            </Typography>
          </Box>
        </Box>

        {/* 버튼 */}
        <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'center' }}>
          <Button
            onClick={onClose}
            sx={{
              width: '120px',
              height: '48px',
              backgroundColor: '#D9D9D9',
              borderRadius: '8px',
              fontSize: '20px',
              fontWeight: 600,
              color: '#404040',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#BFBFBF',
              },
            }}>
            취소
          </Button>
          <Button
            onClick={onConfirm}
            sx={{
              width: '240px',
              height: '48px',
              backgroundColor: '#0F7F85',
              borderRadius: '8px',
              fontSize: '20px',
              fontWeight: 600,
              color: '#FFFFFF',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#0D6A6F',
              },
            }}>
            저장
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SaveConfirmModal;
